import * as Yup from "yup";

// form field names
export type TFormFieldNames = "name" | "description";

// initial values for the form
export const formInitialValues = {
  name: "",
  description: "",
};

// validation schema for the form
export const YupValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Please enter the group name")
    .matches(/^[a-z0-9\-_]+$/, 'Only lowercase characters, numbers, hyphens, and underscores are allowed')
    .max(32, 'Group name must be at most 32 characters long'),

  description: Yup.string()
    .required("Please enter the group description")
});